import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "E:\\hongyou\\background_ui\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "E:\\hongyou\\background_ui\\node_modules\\core-js\\modules\\es6.promise.js";
import "E:\\hongyou\\background_ui\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "E:\\hongyou\\background_ui\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from 'vue';
import Cookies from 'js-cookie';
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets

import 'wow.js/css/libs/animate.css';
import Element from 'element-ui';
import "./styles/element-variables.scss";
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Vue.use(Viewer);
import '@/styles/index.scss'; // global css
import '@/styles/admin.scss';
import "./assets/iconfont/iconfont.css";
import App from "./App";
import store from "./store";
import router from "./router";
import permission from "./directive/permission";
import dragDialog from "./directive/el-drag-dialog";
import { getDicts } from '@/api/system/dict/data';
import { getConfigKey } from '@/api/system/config';
import { parseTime, resetForm, addDateRange, selectDictLabel, download } from '@/utils/costum';
import "./icons"; // icon
import "./permission"; // permission control
import "./utils/error-log"; // error log

import * as filters from "./filters"; // global filters

import Pagination from '@/components/Pagination';
import i18n from "./lang/index";
import rbush from 'rbush';
import 'echarts-liquidfill';
import 'echarts-gl';
import VueSeamlessScroll from 'vue-seamless-scroll';
import VScaleScreen from 'v-scale-screen';
window.rbush = rbush; // 插件能全局访问到 rbush

// 全局方法挂载
Vue.prototype.getDicts = getDicts;
Vue.prototype.getConfigKey = getConfigKey;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.download = download;
Vue.prototype.print = function (obj, type) {
  type = type || 'log';
  var log = JSON.parse(JSON.stringify(obj));
  // console[type](log)
};

import { mockXHR } from "../mock";
if (process.env.NODE_ENV === 'production') {
  mockXHR();
}

// 全局组件挂载
Vue.component('Pagination', Pagination);
Vue.component('VueSeamlessScroll', VueSeamlessScroll);
Vue.prototype.msgInfo = function (msg) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15000;
  this.$message({
    showClose: true,
    message: msg,
    type: 'info',
    duration: duration
  });
};
Vue.prototype.msgSuccess = function (msg) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15000;
  this.$message({
    showClose: true,
    message: msg,
    type: 'success',
    duration: duration
  });
};
Vue.prototype.msgError = function (msg) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15000;
  this.$message({
    showClose: true,
    message: msg,
    type: 'error',
    duration: duration
  });
};
Vue.prototype.notifySuccess = function (title, msg) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15000;
  this.$notify.success({
    title: title,
    message: msg,
    duration: duration
  });
};
Vue.prototype.notifyWarn = function (title, msg) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15000;
  this.$notify.warning({
    title: title,
    message: msg,
    duration: duration
  });
};
Vue.prototype.notifyError = function (title, msg) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15000;
  this.$notify.error({
    title: title,
    message: msg,
    duration: duration
  });
};
Vue.prototype.notifyInfo = function (title, msg) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15000;
  this.$notify.info({
    title: title,
    message: msg,
    duration: duration
  });
};
Vue.use(permission);
Vue.use(dragDialog);
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
});

Vue.use(VScaleScreen);

// register global utility filters
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});

// 全局常量加载
Vue.prototype.GLOBAL = require('@/assets/json/global.json');
Vue.config.productionTip = false;

// console.debug('main env', process.env)

// Vue.L = Vue.prototype.$L = L;
// // leaflet icon
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

new Vue({
  el: '#app',
  store: store,
  router: router,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  }
});